<template>
  <div>
    <ul>
      <li v-for="service in getServices" :key="`service-${service.id}`">
        <h1>[s-{{ service.id}}]: {{ service.name}}</h1>
        <p>{{ service }}</p>
        <ul v-for="actor in getActorsByServiceId(service.id)" :key="`actor-${actor.id}`">
          <h2>[a-{{ actor.id }}]: {{ actor.title }}</h2>
          <p>{{ actor }}</p>
          <ul v-for="varItem in getActorVars(actor)" :key="`var-${varItem.id}`">
            <h3>[v-{{ varItem.id }}]: {{ varItem.description }}</h3>
            <p>{{ varItem }}</p>
          </ul>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DumpAllServices',
  computed: {
    ...mapGetters([
      'getServices',
      'getActorsByServiceId',
      'getActorVars',
    ]),
  },
};
</script>

<style scoped>

</style>
